module.exports = __webpack_public_path__ + "static/media/raffles_home.62351869.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/raffles_home.png
// module id = 518
// module chunks = 0